/* Copyright 2024 Marimo. All rights reserved. */
import { isStaticNotebook } from "../static/static-state";
import { isWasm } from "../wasm/utils";
import { createNetworkRequests } from "./requests-network";
import { createStaticRequests } from "./requests-static";
import { createErrorToastingRequests } from "./requests-toasting";
import type { EditRequests, RunRequests } from "./types";

export function resolveRequestClient(): EditRequests & RunRequests {
  const base = isWasm()
    ? (() => {
        console.warn('WASM mode not supported in library build - falling back to network requests');
        // Fallback to network requests since WASM support is not included in library build
        return createNetworkRequests();
      })()
    : isStaticNotebook()
      ? createStaticRequests()
      : createNetworkRequests();
  return createErrorToastingRequests(base);
}
